<template>
  <b-container fuid>
    <b-modal id="modal-carrier-list" titre="Carrier List" @ok="handleOk" @cancel="handleCancel">
      
      <b-input-group class="pb-2">
        <b-form-input class="mr-sm-2" placeholder="Carrier" v-model="critere" @keyup.enter="get_carrier_list"/>
        <b-input-group-append>
          <b-button variant="outline-success" @click="get_carrier_list">SEARCH</b-button>
        </b-input-group-append>
      </b-input-group>
      
      <b-table
        v-if="rows > 0"
        id="table-carrier-list"
        primary-key="id"
        striped
        hover
        outlined
        table-variant="warning"
        head-variant="danger"
        :items="carrier_list"
        :fields="carrier_fields"
        :per-page="perPage"
        :current-page="currentPage"
        selectable
        select-mode="single"
        @row-selected="onRowSelected"
      >
      <!--
        <template v-slot:cell(code)="data">
          <input type="radio" name="selected_carrier" :value="data.value" v-model="carrier_code" />
        </template>
      -->
      </b-table>
      <b-pagination
        v-show="rows > perPage"
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
      <template v-slot:modal-footer="{ ok, cancel }">
        <!--
        <b-button variant="success" @click="ok()">OK</b-button>
        -->
        <b-button variant="danger" @click="cancel()">Cancel</b-button>
      </template>
    </b-modal>
  </b-container>
</template>

<script>
import { eventBus } from "@/main";
import { mapState } from "vuex";

export default {
  name: "modal-carrier-list",
  data() {
    return {
      critere: "",
      perPage: 10,
      currentPage: 1,
      carrier_code: "",
      carrier_fields: [
        { key: "code", label: "Code" },
        { key: "name", label: "Name", sortable: true }
      ]
    };
  },
  computed: {
    ...mapState(["carrier_list"]),
    rows() {
      return this.carrier_list.length;
    }
  },
  methods: {
    get_carrier_list(bvModalEvt) {
      bvModalEvt.preventDefault();
      let choicelist = true;
      let carrier_name = this.critere;
      this.$store.dispatch("get_carrier_list",{
        choicelist,
        carrier_name
      });
    },
    onRowSelected(items) {
      this.carrier_code = items[0].code;
      this.handleSubmit();
    },
    handleCancel() {
      this.carrier_code = "";
      this.$nextTick(() => {
        this.$bvModal.hide(this.name);
      });
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    handleSubmit() {
      eventBus.$emit("carrier_was_selected_from_modal", this.carrier_code);
      this.$nextTick(() => {
        this.$bvModal.hide("modal-carrier-list");
      });
    }
  }
};
</script>

<style scoped>
div {
  color: red;
}
</style>
